import { Result } from '@standardnotes/domain-core';
import { isErrorResponse } from '@standardnotes/responses';
export class SyncLocalVaultsWithRemoteSharedVaults {
    constructor(sharedVaultServer, mutator) {
        this.sharedVaultServer = sharedVaultServer;
        this.mutator = mutator;
    }
    async execute(localVaults) {
        const remoteVaultsResponse = await this.sharedVaultServer.getSharedVaults();
        if (isErrorResponse(remoteVaultsResponse)) {
            return Result.fail(remoteVaultsResponse.data.error.message);
        }
        const remoteVaults = remoteVaultsResponse.data.sharedVaults;
        const designatedSurvivors = remoteVaultsResponse.data.designatedSurvivors || [];
        for (const localVault of localVaults) {
            if (!localVault.isSharedVaultListing()) {
                continue;
            }
            const remoteVault = remoteVaults.find((vault) => vault.uuid === localVault.sharing.sharedVaultUuid);
            if (remoteVault) {
                const designatedSurvivor = designatedSurvivors.find((survivor) => survivor.sharedVaultUuid === remoteVault.uuid);
                await this.mutator.changeItem(localVault, (mutator) => {
                    /* istanbul ignore next */
                    mutator.sharing = {
                        sharedVaultUuid: remoteVault.uuid,
                        ownerUserUuid: remoteVault.user_uuid,
                        fileBytesUsed: remoteVault.file_upload_bytes_used,
                        designatedSurvivor: designatedSurvivor ? designatedSurvivor.userUuid : null,
                    };
                });
            }
        }
        return Result.ok();
    }
}
